export const Floor = () => {
  return (
    <svg className="dashboard__image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
      <path d="M1.9,22.3C0.7,21.9,0,20.8,0,19.5c0-1.2,0.7-2.3,1.9-2.8L28.4,5.9c1.1-0.4,2.1-0.4,3.2,0L58,16.7c1.2,0.6,2,1.6,2,2.8
        c0,1.3-0.8,2.3-2,2.9L31.5,33.2c-0.5,0.1-1.1,0.2-1.5,0.2c-0.6,0-1.2-0.1-1.6-0.2L1.9,22.3z M2.7,18.4c-0.6,0.2-0.8,0.6-0.8,1.2
        c0,0.6,0.2,1.1,0.8,1.3l26.4,10.8c0.6,0.2,1.2,0.2,1.8,0l26.4-10.8c0.6-0.2,0.9-0.7,0.9-1.3c0-0.6-0.4-0.9-0.9-1.2L30.8,7.6
        c-0.6-0.2-1.2-0.2-1.8,0L2.7,18.4z M58,27.1c1.2,0.5,2,1.4,2,2.8c0,1.3-0.8,2.3-2,2.8L31.5,43.5c-0.5,0.2-1.1,0.2-1.5,0.2
        c-0.6,0-1.2,0-1.6-0.2L1.9,32.8C0.7,32.2,0,31,0,30c0-1.2,0.7-2.3,1.9-2.8C2.3,27,2.9,27,3.2,27.5c0.2,0.5,0,0.9-0.5,1.2
        c-0.6,0.2-0.8,0.6-0.8,1.3c0,0.6,0.2,1.1,0.8,1.3l26.4,10.7c0.6,0.2,1.2,0.2,1.8,0l26.4-10.8c0.6-0.2,0.9-0.8,0.9-1.2
        c0-0.5-0.4-0.9-0.9-1.2c-0.5-0.2-0.7-0.7-0.5-1.2C57,27.1,57.5,27,58,27.1z M58,37.6c1.2,0.6,2,1.6,2,2.9c0,1.2-0.8,2.3-2.1,2.8
        L31.4,54.1c-0.5,0.2-1.1,0.2-1.5,0.2c-0.5,0-1.1,0-1.5-0.2L1.9,43.3C0.7,42.7,0,41.7,0,40.5c0-1.3,0.7-2.3,1.9-2.9
        c0.5-0.1,1.1,0.1,1.3,0.5c0.2,0.5,0,0.9-0.5,1.2c-0.6,0.2-0.8,0.7-0.8,1.3c0,0.5,0.2,0.9,0.8,1.2l26.4,10.8c0.6,0.2,1.2,0.2,1.8,0
        l26.4-10.8c0.6-0.2,0.9-0.7,0.9-1.2c0-0.6-0.4-1.1-0.9-1.3c-0.5-0.2-0.7-0.7-0.5-1.2C57,37.6,57.5,37.5,58,37.6z"/>
    </svg>
  );
};
